import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="timeline"]');

class Timeline {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const swiperComponent = component.querySelector('.swiper');
            if (swiperComponent) this.initSwiper(swiperComponent);
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Pagination, Navigation, Autoplay],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 12,
            autoplay: {
                delay: 20000,
            },
            breakpoints: {
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 48,
                    centeredSlides: true
                }
            },
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperComponent.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
        });
    }
}

(() => {
    if (MODULE) {
        new Timeline();
    }
})();

export default Timeline;
